import { render, staticRenderFns } from "./MenuForm.vue?vue&type=template&id=3cc9eed4&scoped=true&"
import script from "./MenuForm.vue?vue&type=script&lang=js&"
export * from "./MenuForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc9eed4",
  null
  
)

export default component.exports